/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m26 30c0 .552-.448 1-1 1h-18c-.552 0-1-.448-1-1s.448-1 1-1h18c.552 0 1 .448 1 1zm1.5-7.026v4.194c0 .553-.448 1-1 1h-21c-.552 0-1-.447-1-1 0-.552.448-1 1-1h20v-3.194c0-.553.448-1 1-1s1 .447 1 1zm.5-21.974c.552 0 1 .448 1 1v15.38c0 .289-.126.545-.322.727l.004.005-7.5 6.992-.004-.005c-.179.167-.414.273-.678.273h-16.5c-.552 0-1-.448-1-1v-22.372c0-.552.448-1 1-1zm-8.5 16.38c0-.552.448-1 1-1h6.5v-13.38h-22v20.372h14.5zm5.96 1h-3.96v3.692z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;